import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PrimeReactProvider } from 'primereact/api';
import {
    unstable_HistoryRouter as HistoryRouter,
    Routes,
    Route,
} from 'react-router-dom';
import { store, history } from './store';
import App from './components/App';
import ScrollToTop from './components/ScrollToTop';

const primeReactConfig = {
    hideOverlaysOnDocumentScrolling: false,
};

createRoot(document.getElementById('root')).render(
    <PrimeReactProvider value={primeReactConfig}>
        <Provider store={store}>
            <HistoryRouter history={history} basename={process.env.PUBLIC_URL}>
                <ScrollToTop>
                    <Routes>
                        <Route path="/*" element={<App />} />
                    </Routes>
                </ScrollToTop>
            </HistoryRouter>
        </Provider>
    </PrimeReactProvider>
);
